'use strict';

module.exports = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];


//////////////////
// WEBPACK FOOTER
// ./~/@wix/neat-html-parser/build/selfClosingTags.js
// module id = 91
// module chunks = 0 1